"use strict";
var Observable_1 = require('../../Observable');
var merge_1 = require('../../operator/merge');
Observable_1.Observable.prototype.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/merge.js
 ** module id = 1206
 ** module chunks = 0
 **/